import { useNavigate } from "@tanstack/react-router";
import type { MouseEvent, KeyboardEvent } from "react";

/**
 * 一覧の行全体をクリックで詳細へ遷移させる(ユーザー指示 2026-09-14: 文字だけでなく余白でも遷移)。
 * 行の中のリンク・ボタン・入力欄を押したときは遷移しない(それぞれの操作を優先する)。
 */
export function useRowNavigation() {
  const navigate = useNavigate();
  return (projectId: string) => ({
    onClick: (e: MouseEvent<HTMLElement>) => {
      if (isInteractive(e.target as HTMLElement, e.currentTarget)) return;
      void navigate({ to: "/projects/$projectId", params: { projectId } });
    },
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
      if (e.key !== "Enter" || e.target !== e.currentTarget) return;
      void navigate({ to: "/projects/$projectId", params: { projectId } });
    },
  });
}

function isInteractive(target: HTMLElement, row: HTMLElement): boolean {
  const hit = target.closest(
    "a, button, input, select, textarea, [role='menuitem'], [role='dialog']",
  );
  return hit !== null && hit !== row && row.contains(hit);
}
